import { acceptHMRUpdate, defineStore } from 'pinia'
import api from '@api'
import type {
  ConsentTypesEnum, MarketingInputOutput,
  PrivacyConsentsCreatePayload,
  PrivacyConsentsSettingsCreatePayload,
} from '@apiTypes'

export const usePrivacyStore = defineStore('privacy', {
  actions: {
    fetchConsents(token: string, consentTypes: [ConsentTypesEnum]) {
      return api.privacy.privacyConsentsRetrieve({ token, consentTypes }, { skipAuthToken: true })
    },
    setConsents(hash: string, payload: PrivacyConsentsCreatePayload) {
      return api.privacy.privacyConsentsCreate({ token: hash }, payload, { skipAuthToken: true })
    },
    fetchConsentsSettings(token: string) {
      return api.privacy.privacyConsentsSettingsList({ token }, { skipAuthToken: true })
    },
    setConsentsSettings(hash: string, payload: PrivacyConsentsSettingsCreatePayload) {
      return api.privacy.privacyConsentsSettingsCreate({ token: hash }, payload, { skipAuthToken: true })
    },
    fetchTerms(hash: string) {
      return api.privacy.privacyConsentsTermsRetrieve({ token: hash }, { skipAuthToken: true })
    },
    acceptTerms(hash: string, termsId: number) {
      return api.privacy.privacyConsentsTermsCreate({ token: hash }, [{ termsId, accepted: true }], { skipAuthToken: true })
    },
    rejectTerms(hash: string, termsId: number) {
      return api.privacy.privacyConsentsTermsCreate({ token: hash }, [{ termsId, rejected: true }], { skipAuthToken: true })
    },
    fetchMarketing(hash: string) {
      return api.privacy.privacyConsentsMarketingRetrieve({ token: hash }, { skipAuthToken: true })
    },
    setMarketing(hash: string, data: MarketingInputOutput) {
      return api.privacy.privacyConsentsMarketingCreate({ token: hash }, data)
    },
  },
})

if (import.meta.hot)
  import.meta.hot.accept(acceptHMRUpdate(usePrivacyStore, import.meta.hot))
